__turbopack_context__.v({
  "className": "instrument_sans_86cfb3b9-module__OMcyAa__className",
});
